import { render, staticRenderFns } from "./AdverStatistics.vue?vue&type=template&id=72fec15c&scoped=true&"
import script from "./AdverStatistics.vue?vue&type=script&lang=js&"
export * from "./AdverStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AdverStatistics.vue?vue&type=style&index=0&id=72fec15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fec15c",
  null
  
)

export default component.exports